// extracted by mini-css-extract-plugin
export default {"main":"Settings_main__9BAtH","headline":"Settings_headline__OD6zj","settings":"Settings_settings__nDalC"};